var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.LH=require("moment");module.exports=$CLJS.LH;